export const i18nContentHash = 'dd5f639'
